document.addEventListener('DOMContentLoaded', function () {
	// Select both desktop and mobile search buttons
	const searchButtons = document.querySelectorAll(
		'.localads-top-bar__search, .localads-header-top__search-mobile'
	);
	const searchModal = document.getElementById('localads-search-modal');

	console.log('Search Modal Script Loaded');
	console.log('Search Buttons Found:', searchButtons.length);

	if (!searchModal) {
		console.error('Search modal not found');
		return;
	}

	const closeButton = searchModal.querySelector('.localads-search-modal__close');
	const overlay = searchModal.querySelector('.localads-search-modal__overlay');
	const searchInput = searchModal.querySelector('.localads-search-modal__input');
	const modalContent = searchModal.querySelector('.localads-search-modal__content');

	function openModal() {
		console.log('Opening modal...');
		searchModal.setAttribute('aria-hidden', 'false');
		searchModal.classList.add('is-open');
		document.body.style.overflow = 'hidden';

		setTimeout(() => searchInput?.focus(), 300);
	}

	function closeModal() {
		searchModal.setAttribute('aria-hidden', 'true');
		searchModal.classList.remove('is-open');
		document.body.style.overflow = '';
	}

	// Attach click event to both buttons
	searchButtons.forEach(button => {
		button.addEventListener('click', function (e) {
			console.log('Search button clicked:', e.currentTarget);
			openModal();
		});
	});

	closeButton?.addEventListener('click', closeModal);
	overlay?.addEventListener('click', closeModal);

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' && searchModal.classList.contains('is-open')) {
			closeModal();
		}
	});

	modalContent?.addEventListener('click', e => e.stopPropagation());
});
